import { gql } from '@apollo/client';

export const ADD_SITE_IMAGES_MUTATION = gql`
  mutation AddSiteImagesMutation($siteId: String!, $imageIds: [String!]!) {
    addSiteImages(siteId: $siteId, imageIds: $imageIds) {
      ... on UpdateSiteSuccess {
        site {
          id
          image
          imageCropPosition {
            x
            y
          }
          images
          updatedAt
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
